// FIXME TESTAR!!!

(function () {
  'use strict';

  angular
  .module('mgpCorregedoriaApp.validacao')
  .directive('nodeListVisualizacao',NodeListVisualizacao);

  function NodeListVisualizacao($compile,$templateCache){

    var directive = {

      restrict: 'E',
      terminal: true,
      scope: {
        nodes: '=ngModel',
        add: '&',
      },
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element) {
      if (angular.isArray(scope.nodes)) {
        element.append($templateCache.get('sub-registros-visualizacao.html'));
      }
      $compile(element.contents())(scope.$new());
    }
  }
})();
